// 路由
import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    // redirect: "/schoolUserInfo",
    component: Index,
  },
  {
    path: "/bindCrmUser",
    name: "bindCrmUser",
    component: () => import("../views/bindCrmUser.vue"),
  },
  {
    path: "/schoolUserInfo/:configId",
    name: "schoolUserInfo",
    component: () => import("../views/schoolUserInfo.vue"),
  },
  {
    path: "/login/:corpId/:agentId",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/marketingDynamics/:configId",
    name: "marketingDynamics",
    component: () => import("../views/marketingDynamics"),
  },
  {
    path: "/sendCardLink",
    name: "sendCardLink",
    component: () => import("../views/sendCardLink"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/components/detail.vue"),
  },
  {
    path: "/missing_parameter",
    name: "missing_parameter",
    component: () => import("../views/missingParameter"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL || "/",
  routes,
});

// 导航守卫，在路由变化时获取参数
router.beforeEach((to, from, next) => {
  console.log("全局路由守卫11", "to:", to, "from:", from);
  if (to.query.tenantId || sessionStorage.getItem("tenantId"))
    // store.commit("SET_TENANTID", to.query.tenantId);
    store.commit("SET_TENANTID", to.query.tenantId? to.query.tenantId:sessionStorage.getItem("tenantId"));
  console.log("怎么回事？1111", to.query.tenantId, sessionStorage.getItem("tenantId"), store.getters.tenantId);
  // 设置企微地址栏携带的vuex信息
  if (!store.getters.corpId || !store.getters.agentId) {
    if (to.query.corpId || localStorage.getItem("corpId"))
      store.commit("SET_CORPID", to.query.corpId);
    if (to.query.agentId || sessionStorage.getItem("agentId"))
      store.commit("SET_AGENTID", to.query.agentId);
    if (to.params.configId) store.commit("SET_CONFIGID", to.params.configId);
    // 检查登录
  }

  console.warn(
    "Router设置企微信息：",
    "corpId:",
    store.getters.corpId,
    "agentId:",
    store.getters.agentId,
    "configId:",
    store.getters.configId
  );
  // 如果是根路径，参数缺失路径，登录路径 直接放行
  if (
    to.path === "/" ||
    to.path === "/missing_parameter" ||
    to.path.startsWith("/login")
  ) {
    console.log("放学了，直接放行");

    next();
    return;
  }
  // 参数缺失
  if (!store.getters.corpId || !store.getters.agentId) {
    // 缓存当前地址
    const errorParams = {
      to,
      from,
      time: new Date().getTime(),
    };
    localStorage.setItem(
      "MISSING_PARAMETER_CURRENTPATH",
      JSON.stringify(errorParams)
    );
    next("/missing_parameter");
    return;
  }
  next();
});

export default router;
